const pyconfig = {
  apiBaseUrl: "https://model.juristbot.ai"
};

// export default pyconfig;

  // const pyconfig = {
  //   apiBaseUrl: "https://py.juristbot.in"
  // };
 
  // export default pyconfig;

  //   const pyconfig = {
  //   apiBaseUrl: "http://192.168.0.17:8000"
  // };
 
  export default pyconfig;
